<template>
  <ul v-if="value.length" class="divide-y border rounded-lg">
    <li
      v-for="(audience, index) in value"
      :key="audience.id"
      class="pr-4 py-4 hover:bg-gray-50 first:rounded-t-lg last:rounded-b-lg"
    >
      <AudienceListItem :audience="audience" @remove="handleRemoveAudience" />
      <ValidationProvider slim :vid="`audiences.${index}`">
        <template #default="{ errors }">
          <BaseFormGroup>
            <input type="hidden" :value="audience.id" />
            <div v-if="errors.length" class="pl-4">
              <BaseFormInlineMessage danger>
                {{ errors[0] }}
              </BaseFormInlineMessage>
            </div>
          </BaseFormGroup>
        </template>
      </ValidationProvider>
    </li>
  </ul>
  <div v-else class="border rounded-lg px-6 py-4">
    <h2 class="text-lg font-medium text-gray-900">Funnel stage audiences</h2>
    <p class="mt-1 text-sm text-gray-500">
      You haven’t added any audience yet. Get started by selecting audiences to add from the list
      above.
    </p>
  </div>
</template>

<script>
import AudienceListItem from './AudienceListItem.vue';

export default {
  components: { AudienceListItem },
  props: {
    value: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    handleRemoveAudience(audience) {
      this.$emit(
        'input',
        this.value.filter((item) => item.id !== audience.id)
      );
    },
  },
};
</script>
